import { RiAlertLine, RiErrorWarningLine, RiInformationLine } from '@remixicon/react';
import { cva } from 'class-variance-authority';
import { CSSProperties, ReactNode } from 'react';
import { AgText } from 'src/components/ui';
import { cn } from 'src/components/ui/utils';

type BannerVariant = 'warning' | 'error' | 'info';

type Props = {
  variant: BannerVariant;
  title: ReactNode;
  actions?: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const bannerVariants = cva('flex gap-4 p-4 rounded-[5px] border', {
  variants: {
    variant: {
      warning: 'bg-orange-bg text-orange-text border-orange-border',
      error: 'bg-red-text text-white border-red-text',
      info: 'bg-white text-neutral-text border-neutral-5',
    },
  },
});

const icons: Record<BannerVariant, ReactNode> = {
  warning: <RiAlertLine size={24} />,
  error: <RiErrorWarningLine size={24} />,
  info: <RiInformationLine size={24} />,
};

export default function Banner({ title, actions, subtitle, variant, className, style }: Props) {
  return (
    <div className={cn(bannerVariants({ variant }), className)} style={style}>
      {icons[variant]}
      <div className="flex flex-col gap-2 grow">
        <div className="flex gap-2 justify-between">
          <AgText size="16" weight="bold" color="inherit">
            {title}
          </AgText>
          {actions}
        </div>
        {subtitle && (
          <AgText size="14" color="inherit">
            {subtitle}
          </AgText>
        )}
      </div>
    </div>
  );
}
